import {validatePixel} from '../../../privates/validations/styleValidation';
import styleService from './styleService';
import * as members from '../../../privates/privateMembers';
import StyleProperties from '../../../privates/styleConstants';

class BorderWidthMixin {
  /**
   * @member borderWidth
   * @memberof $w.Style
   * @param {external:String} width
   */
    set borderWidth(width) {
        const compName = members._compName.get(this);

        const isValid = validatePixel(width, StyleProperties.BORDER_WIDTH, compName, 'width');
        if (!isValid){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.BORDER_WIDTH, width);
    }

    /**
     * @member borderWidth
     * @label property
     * @syntax
     * get borderWidth(): string
     * set borderWidth(width: string): void
     * @summary Sets or gets the border width of an element.
     * @description
     *  The border width value is a string representing the element's border
     *  width in pixels. For example, `"1px"`.
     *
     * This style can be used with the following elements:
     *
     *  + [`Button`]($w.Button.html)
     *  + [`Checkbox`]($w.Checkbox.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`ProgressBar`]($w.ProgressBar.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html)
     *  + [`UploadButton`]($w.UploadButton.html)
     *
     * @snippet [BorderMixin-borderWidth_set.es6=Set the border width]
     * @snippet [BorderMixin-borderWidth_get.es6=Get the border width]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get borderWidth() {
        return styleService.getStyleParamValue.call(this, StyleProperties.BORDER_WIDTH);
    }
}

export default BorderWidthMixin;
